<template>
  <svg class="icon" viewBox="0 0 1024 1024" :width="size" :height="size">
    <path d="M461.312 601.6l116.736-199.68c4.608-8.192 13.312-12.8 22.528-12.8 9.216 0 17.92 5.12 22.528 12.8l144.384 246.784c4.608 8.192 4.608 17.92 0 26.112-4.608 8.192-13.312 12.8-22.528 12.8H329.216c-14.336 0-26.112-11.776-26.112-26.112 0-4.608 1.024-9.216 3.584-13.312l68.608-117.248c7.168-12.288 23.04-16.384 35.328-9.216 4.096 2.048 7.168 5.632 9.216 9.216l41.472 70.656z m-50.688-146.944c-34.816 0-62.976-29.184-62.976-65.024 0-35.84 28.16-65.024 62.976-65.024 34.816 0 62.976 29.184 62.976 65.024 0 35.84-28.16 65.024-62.976 65.024zM138.752 165.888H348.16v-50.688H136.704c-26.112 0-47.104 20.992-47.104 47.104v151.04h49.152V165.888zM138.752 846.848v-182.784h-49.152v186.368c0 26.112 20.992 47.104 47.104 47.104H348.16v-50.688H138.752zM884.224 165.888v147.456h49.664V162.304c0-26.112-20.992-47.104-47.104-47.104h-187.904v50.688h185.344zM884.224 846.848h-185.344v50.688h187.904c26.112 0 47.104-20.992 47.104-47.104v-186.368h-49.664v182.784z"></path>

  </svg>
</template>

<script>
export default {
  props: {
    size: {
      default: '24'
    }
  }
}
</script>
